import {useEffect, useState} from "react";
import * as Sentry from "@sentry/react";
import {useAccessToken} from "./useAccessToken";

/**
 * @param {string} data base64 encoded binary data
 * @param {string} type MIME content type
 * @return {Blob}
 * */
function b64toBlob(data, type) {
    const byteString = atob(data); // NOTE: atob is deprecated for the node only, it is still relevant for browsers
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
}

/**
 * @param {string | number} buildingId
 * @param {string | number} partnerId
 * @return {{ noImage: boolean, reason: 'absent' | 'failed' | null, objectUrl: string | null } | null}
 * */
export function useManagementCompanyLogo(buildingId, partnerId) {

    const client = useAccessToken();
    const [mcLogo, setMcLogo] = useState(null);

    useEffect(() => (buildingId || partnerId) && getLogo(), [buildingId, partnerId]);

    async function getLogo() {
        let response = null;
        try {
            response = buildingId ? await client.managers.buildings.getPartnerLogo(buildingId) : await client.partners.getPartnerLogo(partnerId);
            const noImage = !response.imageExists;
            const objectUrl = noImage ? null : URL.createObjectURL(b64toBlob(response.imageData, response.imageType));
            const reason = noImage ? 'absent' : null;
            setMcLogo({ noImage, reason, objectUrl });
        } catch (e) {
            console.error(e);
            console.log('Erroneous resp', response);
            Sentry.captureMessage(`Unable to get management company logo`, 'error');
            setMcLogo({ noImage: true, reason: 'failed', objectUrl: null });
        }
    }

    return mcLogo;
}
